export const shippingTypes = {
  ImportUkraine: 0,
  ExportUkraine: 1,
  OutsideUkraine: 2,
  InsideUkraine: 3,
};